import React, { useEffect, useState } from 'react';
import Button from '../../common/Button.js';
import Alert from '../../common/Alert.js';
import {
  emptyParcel,
  recomputeParcel,
  validateCargoParcels,
} from '../../../utils/cargoParcelUtils.js';
import PackageDimensionForm from './PackageDimensionForm.js';
import PackageDimensionModalShell from './PackageDimensionModalShell.js';

const EditPackageDimensionModal = ({ isOpen, onClose, onSave, parcels, ratePerKg = 0 }) => {
  const [draft, setDraft] = useState([emptyParcel(1)]);

  useEffect(() => {
    if (!isOpen) return;
    const source = Array.isArray(parcels) && parcels.length ? parcels : [emptyParcel(1)];
    setDraft(source.map(recomputeParcel));
  }, [isOpen, parcels]);

  if (!isOpen) return null;

  const handleSave = () => {
    const error = validateCargoParcels(draft, 1);
    if (error) {
      Alert.error(error);
      return;
    }
    onSave(draft.map(recomputeParcel));
    onClose();
  };

  return (
    <PackageDimensionModalShell
      title="Edit Package Dimensions"
      onClose={onClose}
      footer={
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-3">
          <Button type="button" variant="secondary" onClick={onClose} className="w-full sm:w-auto">
            Cancel
          </Button>
          <Button type="button" variant="primary" onClick={handleSave} className="w-full sm:w-auto">
            Update Packages
          </Button>
        </div>
      }
    >
      <PackageDimensionForm parcels={draft} onChange={setDraft} ratePerKg={ratePerKg} />
    </PackageDimensionModalShell>
  );
};

export default EditPackageDimensionModal;
